import { Dispatch, SetStateAction } from 'react'
import { Dropzone, FileMosaic } from '@dropzone-ui/react'
import toast from 'react-hot-toast';

import { Tr4inerContainedButton } from '../../../Utils/Button';
import { imgManShortV2, imgManShortV3, imgWomanShortV2, imgWomanShortV3 } from '../../../Shared/Images/Cuestionario';
import { IUserFromStorage } from '../../../Interfaces/IUser';
import { compressImage, convertHeicToJpeg, isHeic } from '../../../Utils/image';


interface Props {
  setImgBase64Data: Dispatch<SetStateAction<string[]>>;
  setFiles: Dispatch<SetStateAction<any[]>>;
  setSection: Dispatch<SetStateAction<number>>;
  files: any[];
  sexo: boolean;
  isMobile: boolean;
  user: IUserFromStorage;
}

const FotosEvaluacion = ({setImgBase64Data, setFiles, setSection, sexo, files, isMobile, user}: Props) => {

  const updateFiles = async (incommingFiles: any[]) => {
    const aux: string[] = [];
    const validFiles: any[] = [];

    const toastId = toast.loading("Procesando imágenes...");

    for (const e of incommingFiles) {
      if (e.valid === true) {
        //* Valida el peso de la imagen 11mb máximo
        if (e.file.size >= 11 * 1024 * 1024) {
          toast.error(`La imagen "${e.file.name}" es demasiado grande (máx 11 MB).`);
          continue; //* se salta la imagen rechazada
        }

        try {
          //* Si es HEIC pasa a JPEG antes de comprimir, ya mucho tuve que hacer manualmente xd
          let fileToProcess: File = e.file;
          if (isHeic(e.file)) {
            fileToProcess = await convertHeicToJpeg(e.file);
            e.file = fileToProcess;
            e.name = fileToProcess.name;
            e.type = fileToProcess.type;
            e.size = fileToProcess.size;
          }

          const compressedBase64 = await compressImage(fileToProcess, 0.7, 1280, 720, "image/webp");
          aux.push(compressedBase64);
          e.base64 = compressedBase64;
          validFiles.push(e);
        } catch (error) {
          console.error(error);
          toast.error(`No se pudo procesar la imagen "${e.file.name}".`);
        }
      }
    }
    
    //* Solo  se actualizan si hay imágenes válidas, ya tuve error si no dx
    toast.dismiss(toastId);

    if (validFiles.length > 0) {
      setImgBase64Data(aux);
      setFiles(validFiles);
    } else {
      setImgBase64Data([]);
      setFiles([]);
    }
  };

  const onDelete = (id: any) => {
    const updatedFiles = files.filter((x: any) => x.id !== id);
    setFiles(updatedFiles);
    setImgBase64Data(updatedFiles.map(file => file.base64));
  };

  const handleNext = () => {
    let err1 = false ;

    if (user.esReto && files.length < 4) {
      err1 = true;
    } else if (!user.esReto && files.length < 3) {
      err1 = true;
    }

    if (err1) {
      toast.error(`Tienen que ser mínimo ${user.esReto ? 4 : 3} imágenes 😢.`);
      return;
    }

    if(!err1) {
      setSection((sec:number) => sec + 1);
    }

  }

  return (
    <>
      <section className="flex flex-col gap-1 font-bold justify-center items-center mt-2">
        <b className="text-orangeTr4iner text-xl text-center">Sube tus fotos</b>

        <div className="flex flex-col items-center justify-center w-max m-auto text-sm md:text-base">

          <div className="my-3 flex justify-start items-center font-semibold w-full">
            <span className="h4 font-bold text-center">1&nbsp;.&nbsp;</span>
            Torso descubierto, con SHORT deportivo.
          </div>

          <div className="flex justify-start items-center font-semibold mb-2 w-full">
            <span className="h4 font-bold">2&nbsp;.&nbsp;</span>
            Tómalas apenas te levantas, frente a una pared clara
          </div>

          <div className="justify-start items-left w-full flex flex-col font-semibold">
            <div className="w-full flex items-center">
              <span className="h4 font-bold ">3&nbsp;.&nbsp;</span>
              Debes girar lentamente mostrando {user.esReto ? '4' : '3'} posiciones:
            </div>
            <ul className="list-disc ml-4 items-start flex flex-col justify-start text-sm">
              <li>De frente</li>
              <li>De perfil {user.esReto && 'derecho'}</li>
              {user.esReto && (  
                <li>De perfil izquierdo</li>
              )}
              <li>De espalda</li>
            </ul>
          </div>
          
          {!user.esReto ? (
            <div className="flex justify-start items-center w-full font-semibold">
              <span className="h4 font-bold p-0 m-0">4&nbsp;</span>
              De cuerpo entero.
            </div>
          ) : (
            <>
              <div className="flex justify-start items-center w-full text-start mb-3 font-semibold">
                <span className="h4 font-bold p-0 m-0">4&nbsp;</span>
                Fotos de cuerpo completo, que se vea desde la {isMobile && <br/>} cabeza hasta los pies.
              </div>
              <div className="flex justify-start items-center w-full mb-3 font-semibold">
                <span className="h4 font-bold p-0 m-0">5&nbsp;</span>
                Las fotos deben ser como el ejemplo mostrado
              </div>
              <div className="flex justify-start items-center w-full mb-3 font-semibold">
                <span className="h4 font-bold p-0 m-0">6&nbsp;</span>
                En cada foto debes sostener un cartel que diga: <br />
                "Reset 8 semanas - Dia 30"
              </div>
            </>
          )}
          
        </div>
        <div className="flex text-center items-center justify-center">
          {user.esReto ? (
          <img src={sexo ? imgManShortV3 : imgWomanShortV3} width={!isMobile ? '30%' : '60%'} alt="img" />
        ) : (
          <img src={sexo ? imgManShortV2 : imgWomanShortV2} width={!isMobile ? '30%' : '60%'} alt="img" />
        )}
        </div>
        <div className="lg:w-[70%] w-[80%] m-auto flex justify-center">
          <Dropzone
            onChange={updateFiles}
            accept="image/*,.heic,.heif"
            localization='ES-es'
            label='Sube tus archivos aquí'
            maxFiles={user.esReto ? 4 : 3}
            header={false}
            value={files}
          >
            {files
              .filter((e: any) => e.valid === true)
              .map((file: any) => (
                <FileMosaic {...file} key={file.id} onDelete={onDelete} preview />
            ))}
          </Dropzone>
        </div>
        <p className="text-slate-400 text-xs text-left mt-2">
          Respetamos tu privacidad. Estas fotos no se divulgarán sin tu consentimiento.
        </p>
      </section>

      <div className="flex justify-center w-full">
        <div className="self-center">
          <Tr4inerContainedButton
            variant="contained"
            size="large"
            sx={{
              textTransform: 'capitalize',
              fontWeight: 'bold',
              fontSize: '1.2rem',
            }}
            onClick={() => {
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
              handleNext();
            }}
          >
            {`Siguiente`}
          </Tr4inerContainedButton>
        </div>
      </div>

    </>
  )
}

export default FotosEvaluacion